import Vue from 'vue'
import store from '@/store'

const URL = store.state.apiUrl + '/api/v1'

export const login = (data) => {
  const params = {
    'username': data.username,
    'password': data.password
  }

  return Vue.http.post(URL + '/login', params, null)
    .then((response) => {
      store.commit('LOGIN', response.body.data)
    })
}

export const logout = () => {
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${store.getters.auth.user.api_token}`
  }
  return Vue.http.get(URL + '/logout', {
    headers
  })
    .then((response) => {
      store.commit('LOGOUT')
    })
    .catch((err) => {
      console.log(err)
    })
}

export const changeOutlet = (outletID) => {
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${store.getters.auth.user.api_token}`
  }
  console.log(headers)
  return Vue.http.get(`${URL}/change-outlet/${outletID}`, {
    headers
  })
    .then((response) => {
      store.commit('changeOutlet', response.body)
    })
    .catch((err) => {
      console.log(err)
    })
}



// WEBPACK FOOTER //
// ./src/services/auth.js